import React, { Component, Fragment } from "react";
import {
	Form,
	Input,
	Slider,
	Row,
	Col,
	Tabs,
	Select,
	Button,
	InputNumber,
	Icon,
	Tooltip,
	Popconfirm,
	Modal
} from "antd";
import co from "co";
import { observer, inject } from "mobx-react";
import _ from "lodash";
import { Guides } from "common/guides";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const TabPane = Tabs.TabPane;
const Option = Select.Option;

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 6 }
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 18 }
	}
};

const pType = ["primary", "secondary", "branded", "generic", "nakedUrl"];

const keywordHelp = {
	primary: "More than one keyword is recommended",
	secondary:
		"Keywords related to your primary keywords. \nEx: controlling your dog (Main keyword: dog traning)",
	branded:
		"Brand/Business name. \nEx: John's Dog School. (Main keyword: dog training)",
	generic: "Anchor text like: click here, learn more",
	nakedUrl: "Use domains/urls as anchor text",
	tags: "Tags are separated by , (colon character)"
};

const tierLinkSetIdRegex = /linksAndKeywords\[(\d+)\].linkSets\[(\d+)\]/;

function handleValueChange(props, changedValues, allValues) {
	// console.log(">>>", allValues);
  }

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},
	
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class GeneralTierForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeKey: "1"
		};
	}

	validateForm = () => {
		// console.log("Validating General Tier Form");
		var that = this;
		return new Promise(resolve => {
			this.props.form.validateFieldsAndScroll(
				{ scroll: { offsetBottom: 100 }, force: true },
				(err, vals) => {
					if (err && err.linksAndKeywords) {
						if (err.linksAndKeywords[0]) {
							let linkSets = err.linksAndKeywords[0].linkSets;
							if (linkSets) {
								for (
									let linkSetId = 0;
									linkSetId < linkSets.length;
									linkSetId++
								) {
									let linkSet = linkSets[linkSetId];
									if (linkSet) {
										// console.log(
										// 	"Failed at link set",
										// 	linkSetId
										// );
										this.setActiveKey(
											_.toString(linkSetId + 1)
										);
										break;
									}
								}
							}
						}
					}
					resolve(err);
				}
			);
		});
	};

	copySettings = () => {
		// console.log(this.sourceTier);
		if (this.sourceTier != undefined && this.sourceTier >= 0) {
			this.props.copySettings(this.props.tier, this.sourceTier);
		}
	};

	linksValidator = (rule, value, callback) => {
		// console.log("Validating", value);
		if (value == null || value == undefined) {
			callback("Required");
		}
		const tier = this.props.tier;
		let minLinks = this.props.form.getFieldValue(
			`linksAndKeywords[${tier}].minLinks`
		);
		let maxLinks = value;
		if (minLinks > maxLinks) {
			callback("Max links must be greater or equal to min links");
			return;
		} else {
			callback();
		}
	};

	keywordValidator = (rule, value, callback) => {
		// console.log("Validating keyword");
		if (!rule.field) {
			callback();
			return;
		}

		let tmp = rule.field.split(".");
		let type = tmp[tmp.length - 1].replace("Keyword", "");

		let res = rule.field.match(tierLinkSetIdRegex);
		let tier = res[1];
		let linkSetId = res[2];

		if (!value) {
			// const tier = this.props.tier;
			if (
				this.props.form.getFieldValue(
					`linksAndKeywords[${tier}].linkSets[${linkSetId}].${type}Percentage`
				) != 0
			) {
				let cType = _.capitalize(type);
				callback(cType + " keyword is required");
				return;
			}
		}

		callback();
	};

	secondaryKeywordValidator = (rule, value, callback) => {
		this.keywordValidator(rule, value, callback, "secondary");
	};

	genericKeywordValidator = (rule, value, callback) => {
		this.keywordValidator(rule, value, callback, "generic");
	};

	renderKeywordAndPercentage = (type, key) => {
		const tier = this.props.tier;
		let cType = _.capitalize(type);

		if (type == "primary") {
			return (
				<Col span={6} key={type}>
					<FormItem
						label={
							<span>
								{cType +
									" Keywords - " +
									this.props.form.getFieldValue(
										`linksAndKeywords[${tier}].linkSets[${key}].${type}Percentage`
									) +
									"%"}
								{'  '}
								<Tooltip title={keywordHelp[type]}>
									<Icon
										type="question-circle"
										theme="twoTone"
										// style={{ fontSize: "22px" }}
									/>
								</Tooltip>
							</span>
						}
						colon={false}
						style={{ marginBottom: 10 }}
					>
						{this.props.form.getFieldDecorator(
							`linksAndKeywords[${tier}].linkSets[${key}].primaryPercentage`,
							{
								rules: [
									{
										type: "integer",
										min: 1,
										message:
											"Primary percentage must be greater than zero"
									}
								]
							}
						)(<Slider disabled={true} />)}
					</FormItem>
					<FormItem>
						{this.props.form.getFieldDecorator(
							`linksAndKeywords[${tier}].linkSets[${key}].primaryKeyword`,
							{
								rules: [
									{
										required: true,
										message: "Primary keyword is required"
									}
								]
							}
						)(
							<TextArea
								style={{ fontFamily: "Arial", resize: "none" }}
								rows={3}
								autoComplete="off"
								autoCorrect="off"
								autoCapitalize="off"
								spellCheck="false"
							/>
						)}
					</FormItem>
				</Col>
			);
		}

		if (type == "nakedUrl") {
			return (
				<Col span={6} key={type}>
					<FormItem
						label={
							<span>
								{"Naked URL - " +
									this.props.form.getFieldValue(
										`linksAndKeywords[${tier}].linkSets[${key}].nakedUrlPercentage`
									) +
									"%"}
								{'  '}
								<Tooltip title={keywordHelp[type]}>
									<Icon
										type="question-circle"
										theme="twoTone"
										// style={{ fontSize: "22px" }}
									/>
								</Tooltip>
							</span>
						}
						colon={false}
						style={{ marginBottom: 10 }}
					>
						{this.props.form.getFieldDecorator(
							`linksAndKeywords[${tier}].linkSets[${key}].nakedUrlPercentage`
						)(<Slider />)}
					</FormItem>
				</Col>
			);
		}

		return (
			<Col span={6} key={type}>
				<FormItem
					label={
						<span>
							{cType +
								" Keywords - " +
								this.props.form.getFieldValue(
									`linksAndKeywords[${tier}].linkSets[${key}].${type}Percentage`
								) +
								"%"}
							{'  '}
							<Tooltip title={keywordHelp[type]}>
								<Icon
									type="question-circle"
									theme="twoTone"
									// style={{ fontSize: "22px" }}
								/>
							</Tooltip>
						</span>
					}
					colon={false}
					style={{ marginBottom: 10 }}
				>
					{this.props.form.getFieldDecorator(
						`linksAndKeywords[${tier}].linkSets[${key}].${type}Percentage`
					)(<Slider />)}
				</FormItem>
				<FormItem>
					{this.props.form.getFieldDecorator(
						`linksAndKeywords[${tier}].linkSets[${key}].${type}Keyword`,
						{
							rules: [
								{
									validator: this.keywordValidator
								}
							]
						}
					)(
						<TextArea
							style={{ fontFamily: "Arial", resize: "none" }}
							rows={3}
							autoComplete="off"
							autoCorrect="off"
							autoCapitalize="off"
							spellCheck="false"
						/>
					)}
				</FormItem>
			</Col>
		);
	};

	addNewLinkSet = () => {
		this.props.addNewLinkSet();
		const tier = this.props.tier;
		this.setState({
			activeKey: _.toString(
				this.props.fields.linksAndKeywords[tier].linkSets.length + 1
			)
		});
	};

	showConfirmAddingNewLinkSet = () => {
		Modal.confirm({
			title: "Do you want add new link set?",
			content: (<span>Adding a new link set will help you do <a href={Guides["link-matching"]} target="_blank">URLs-Keywords Matching.</a></span>),
			onOk: this.addNewLinkSet
		})
	}

	setActiveKey = activeKey => {
		this.setState({ activeKey });
	};

	handleTabChange = activeKey => {
		this.setState({ activeKey });
	};

	removeLinkSet = (targetKey, action) => {
		if (action === "remove") {
			Modal.confirm({
				title: "Remove link set",
				content: "Do you want to remove link set?",
				onOk: () => {
					this.props.removeLinkSet(_.parseInt(targetKey - 1));
					this.setActiveKey("1");
				}
			})						
		}
	};

	render() {
		const tier = this.props.tier;
		const closable =
			this.props.fields.linksAndKeywords[tier].linkSets.length > 1;
		return (
			<Fragment>
				{tier == 0 ? (
					""
				) : (
					<Row>
						<Button type="primary" onClick={this.copySettings}>
							Copy settings
						</Button>
						<span>{'  '}from{'  '}</span>
						<Select
							style={{ width: 120 }}
							placeholder="Select a tier"
							onChange={value => {
								this.sourceTier = value;
							}}
						>
							{_.times(this.props.nTier, i => {
								if (i != this.props.tier) {
									return (
										<Option key={i} value={i}>{`Tier ${i +
											1}`}</Option>
									);
								}
							})}
						</Select>
					</Row>
				)}
				<Row>
					<Col span={12}>
						<FormItem
							style={{ maxWidth: 360, marginBottom: 10 }}
							label="Links per post"
						>
							<Row>
								<Col span={12}>
									<FormItem
										label="Min"
										{...formItemLayout}
										style={{ marginBottom: 10 }}
									>
										{this.props.form.getFieldDecorator(
											`linksAndKeywords[${tier}].minLinks`,
											{
												rules: [
													{
														required: true,
														type: "integer",
														min: 0,
														max: 20,
														message:
															"Must be a number between 0 and 20"
													}
												]
											}
										)(<InputNumber />)}
									</FormItem>
								</Col>
								<Col span={12}>
									<FormItem
										label="Max"
										{...formItemLayout}
										style={{ marginBottom: 10 }}
									>
										{this.props.form.getFieldDecorator(
											`linksAndKeywords[${tier}].maxLinks`,
											{
												rules: [
													{
														required: true,
														type: "integer",
														min: 0,
														max: 20,
														message:
															"Must be a number between 0 and 20 and greater or equal to min links",
														validator: this
															.linksValidator
													}
												]
											}
										)(<InputNumber />)}
									</FormItem>
								</Col>
							</Row>
						</FormItem>
					</Col>
					<Col span={12}>
						<FormItem label="Link Position">
							{this.props.form.getFieldDecorator(
								`linksAndKeywords[${tier}].linkPosition`,
								{
									rules: [
										{
											required: true,
											message:
												"Place select link position"
										}
									]
								}
							)(
								<Select
									style={{ width: 200 }}
									placeholder="Select link position"
								>
									<Option
										key="ReplaceKeyword"
										value="ReplaceKeyword"
									>
										Replace Keywords
									</Option>
									<Option key="Top" value="Top">
										Top
									</Option>
									<Option key="Bottom" value="Bottom">
										Bottom
									</Option>
									<Option
										key="RandomSentence"
										value="RandomSentence"
									>
										Between Sentences
									</Option>
									<Option
										key="RandomParagraph"
										value="RandomParagraph"
									>
										Between Paragraphs
									</Option>
									<Option
										key="ReplaceLinkTag"
										value="ReplaceLinkTag"
									>
										Replace Link Tags
									</Option>
									<Option
										key="InBlurbOnly"
										value="InBlurbOnly"
									>
										In Blurb Only
									</Option>
								</Select>
							)}
						</FormItem>
					</Col>					
				</Row>
				<Row>
					<FormItem label={
						<span>
							Tags{' '}
							<Tooltip title={keywordHelp["tags"]}>
								<Icon
									type="question-circle"
									theme="twoTone"									
								/>
							</Tooltip>													
						</span>
					} colon={false}>
						{this.props.form.getFieldDecorator(
							`linksAndKeywords[${tier}].tags`,
							{
								rules: [
									{
										required: true,
										message: "Tags are required"
									}
								]
							}
						)(
							<Input type="text"																				
								autoComplete="off"
								autoCorrect="off"
								autoCapitalize="off"
								spellCheck="false"
							/>
						)}
					</FormItem>							
				</Row>		
				{tier == 0 ? (
					<Fragment>
						<Row>							
							<Button
								type="primary"
								size="small"
								onClick={this.showConfirmAddingNewLinkSet}
							>
								Add new link set
							</Button>							
						</Row>
						{/* <Divider type="horizontal" /> */}
						<Tabs
							animated
							activeKey={this.state.activeKey}
							type="editable-card"
							hideAdd={true}
							onChange={this.handleTabChange}
							onEdit={this.removeLinkSet}
						>
							{this.props.fields.linksAndKeywords[
								tier
							].linkSets.map((value, key) => {
								return (
									<TabPane
										tab={`Link Set ${key + 1}`}
										key={`${key + 1}`}
										closable={closable}
									>
										<Row gutter={8}>
											<Col span={6}>
												<FormItem
													label="URLs"
													style={{ marginBottom: 10 }}
												>
													{this.props.form.getFieldDecorator(
														`linksAndKeywords[${tier}].linkSets[${key}].urls`,
														{
															rules: [
																{
																	required: true,
																	message:
																		"URLs are required"
																}
															]
														}
													)(
														<TextArea
															style={{
																fontFamily:
																	"Arial",
																resize: "none"
															}}
															rows={3}
															autoComplete="off"
															autoCorrect="off"
															autoCapitalize="off"
															spellCheck="false"
														/>
													)}
												</FormItem>
											</Col>
										</Row>
										<Row gutter={8}>
											{pType.map(type => {
												return this.renderKeywordAndPercentage(
													type,
													key
												);
											})}
										</Row>																		
									</TabPane>
								);
							})}
						</Tabs>
					</Fragment>
				) : (
					<Fragment>
						<Row gutter={8}>
							{pType.map(type => {
								return this.renderKeywordAndPercentage(type, 0);
							})}
						</Row>
					</Fragment>
				)}
			</Fragment>
		);
	}
}

@inject("rootStore")
@observer
class MainTabs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeKey: "tier1"
		};
	}

	setActiveKey = activeKey => {
		this.setState({ activeKey });
	};

	handleTabChange = activeKey => {
		this.setState({ activeKey });
	};

	render() {
		return (
			<Tabs
				tabPosition="left"
				activeKey={this.state.activeKey}
				onChange={this.handleTabChange}
				animated={false}
			>
				{this.props.tabPanes}
			</Tabs>
		);
	}
}

@inject("rootStore")
@observer
class GeneralTab extends Component {
	internalForms = [];
	currentChanges = {};

	fieldsChanged = _.debounce(changedFields => {		
		// console.log("Changed", this.currentChanges);
		const {
			rootStore: { xwizardStore }
		} = this.props;
		xwizardStore.formChanged(_.cloneDeep(changedFields));
		this.currentChanges = {};
	}, 1000);

	onFieldsChange = (changedFields) => {
		this.currentChanges = _.merge(this.currentChanges, changedFields);		
		this.fieldsChanged(this.currentChanges);		
		// this.fieldsChanged(changedFields);
	}

	// onFieldsChange = _.debounce(changedFields => {
	// 	const {
	// 		rootStore: { xwizardStore }
	// 	} = this.props;
	// 	xwizardStore.formChanged(changedFields);
	// }, 1000);

	componentWillUnmount = () => {
		this.fieldsChanged.cancel();
	};

	validateForm = () => {
		return co(
			function*() {
				// console.log(
				// 	"Number of forms are: " + this.internalForms.length
				// );
				for (let tier = 0; tier < this.internalForms.length; tier++) {
					let internalForm = this.internalForms[tier];
					let result = yield internalForm.validateForm();
					if (result != null) {
						this.mainTabs.setActiveKey(`tier${tier + 1}`);
						return result;
					}
				}
				return null;
			}.bind(this)
		);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		const stateForm = xwizardStore.stateForm;

		let data = {
			linksAndKeywords: []
		};

		for (let i = 0; i < stateForm.linksAndKeywords.length; i++) {
			let linksAndKeywords = stateForm.linksAndKeywords[i];
			let linkSets = [];
			for (let j = 0; j < linksAndKeywords.linkSets.length; j++) {
				linkSets.push({
					urls:
						i == 0
							? Form.createFormField(
									linksAndKeywords.linkSets[j].urls
							  )
							: undefined,
					primaryKeyword: Form.createFormField(
						linksAndKeywords.linkSets[j].primaryKeyword
					),
					secondaryKeyword: Form.createFormField(
						linksAndKeywords.linkSets[j].secondaryKeyword
					),
					brandedKeyword: Form.createFormField(
						linksAndKeywords.linkSets[j].brandedKeyword
					),
					genericKeyword: Form.createFormField(
						linksAndKeywords.linkSets[j].genericKeyword
					),

					primaryPercentage: Form.createFormField(
						linksAndKeywords.linkSets[j].primaryPercentage
					),
					secondaryPercentage: Form.createFormField(
						linksAndKeywords.linkSets[j].secondaryPercentage
					),
					brandedPercentage: Form.createFormField(
						linksAndKeywords.linkSets[j].brandedPercentage
					),
					genericPercentage: Form.createFormField(
						linksAndKeywords.linkSets[j].genericPercentage
					),
					nakedUrlPercentage: Form.createFormField(
						linksAndKeywords.linkSets[j].nakedUrlPercentage
					)					
				});
			}

			let tierData = {
				minLinks: Form.createFormField(linksAndKeywords.minLinks),
				maxLinks: Form.createFormField(linksAndKeywords.maxLinks),
				linkPosition: Form.createFormField(
					linksAndKeywords.linkPosition
				),
				tags: Form.createFormField(
					linksAndKeywords.tags
				),
				linkSets: linkSets
			};
			// if (i == 0) {
			// 	tierData = {
			// 		...tierData,
			// 		urls: Form.createFormField(linksAndKeywords[0].urls)
			// 	};
			// }
			data.linksAndKeywords.push(tierData);
		}

		return data;
	};

	copySettings = (destTier, srcTier) => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		xwizardStore.copyGeneralSettings(destTier, srcTier);
	};

	addNewLinkSet = () => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		xwizardStore.addNewLinkSet();
	};

	removeLinkSet = linkSetId => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		xwizardStore.removeLinkSet(linkSetId);
	};

	render() {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		const stateForm = xwizardStore.stateForm;

		let fields = this.mapPropsToFields();
		let tabPanes = [];

		this.internalForms = [];

		for (let tier = 0; tier < xwizardStore.wizard.depth; tier++) {
			const tabName = `Tier ${tier + 1}`;
			const tabKey = `tier${tier + 1}`;
			let tabPane = (
				<TabPane
					tab={tabName}
					key={tabKey}
					forceRender={true}
					// style={{ minHeight: (window.screen.height * 60) / 100 }}
				>
					{/* <Form> */}
					<GeneralTierForm
						tier={tier}
						// nTier={stateForm.linksAndKeywords.length}
						nTier={xwizardStore.wizard.depth}
						nLinkSets={stateForm.linksAndKeywords.length}
						fields={fields}
						copySettings={this.copySettings}
						onFieldsChange={this.onFieldsChange}
						addNewLinkSet={this.addNewLinkSet}
						removeLinkSet={this.removeLinkSet}
						wrappedComponentRef={internalForm => {
							if (internalForm != null) {
								this.internalForms.push(internalForm);
							}
						}}
					/>
					{/* </Form> */}
				</TabPane>
			);
			tabPanes.push(tabPane);
		}
		return (
			<MainTabs
				tabPanes={tabPanes}
				ref={mainTabs => {
					if (mainTabs != null) {
						this.mainTabs = mainTabs.wrappedInstance;
					}
				}}
			/>
		);
	}
}

export default GeneralTab;
